/* batida-b2b-footer.js (9.10.2026, Horizon P8): behaviour of the b2b.batida.pl footer (sections/batida-b2b-footer), ported 1:1 from Pipeline's theme.js,
   without jQuery / theme.js:
     1. phone accordions (< 768 px): the three columns "O nas" / "Mapa strony" / "Kontakt" open and close (the first two are open by default, the live
        settings), slide 500 ms, opening one closes its siblings, Escape closes (theme.js: Accordion, slideDown / slideUp)
     2. newsletter form: a normal POST to Shopify's customer form (exactly as live); the form id is kept in sessionStorage so that the page that comes back
        shows the success / error line (classes has-success / has-error on the form, theme.js: NewsletterCheckForResult)
     3. floating label of the e-mail field (theme.js: floatLabels)
   The language pill is <popout-select> (assets/batida-header.js), the cookie link is assets/batida-cookie-settings.js. */
(function () {
  'use strict';
  var root = document.getElementById('footer-group') || document;
  var MEDIUM = 768, OPEN = 'accordion-is-open', DUR = 500;

  /* ---- slide helpers (theme.js slideDown / slideUp) ---- */
  function clear(t) {
    ['height', 'padding-top', 'padding-bottom', 'margin-top', 'margin-bottom', 'overflow', 'transition-duration', 'transition-property', 'transition-timing-function'].forEach(function (p) { t.style.removeProperty(p); });
  }
  function slideDown(t) {
    var display = getComputedStyle(t).display;
    if (display !== 'none') return;
    t.style.removeProperty('display');
    t.style.display = 'block';
    var h = t.offsetHeight;
    t.style.overflow = 'hidden'; t.style.height = 0; t.style.paddingTop = 0; t.style.paddingBottom = 0; t.style.marginTop = 0; t.style.marginBottom = 0;
    void t.offsetHeight;
    t.style.boxSizing = 'border-box';
    t.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
    t.style.transitionProperty = 'height, margin, padding';
    t.style.transitionDuration = DUR + 'ms';
    t.style.height = h + 'px';
    ['padding-top', 'padding-bottom', 'margin-top', 'margin-bottom'].forEach(function (p) { t.style.removeProperty(p); });
    setTimeout(function () {
      ['height', 'overflow', 'transition-duration', 'transition-property', 'transition-timing-function'].forEach(function (p) { t.style.removeProperty(p); });
    }, DUR);
  }
  function slideUp(t) {
    t.style.transitionProperty = 'height, margin, padding';
    t.style.transitionTimingFunction = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
    t.style.transitionDuration = DUR + 'ms';
    t.style.boxSizing = 'border-box';
    t.style.height = t.offsetHeight + 'px';
    void t.offsetHeight;
    t.style.overflow = 'hidden'; t.style.height = 0; t.style.paddingTop = 0; t.style.paddingBottom = 0; t.style.marginTop = 0; t.style.marginBottom = 0;
    setTimeout(function () { t.style.display = 'none'; clear(t); }, DUR);
  }

  /* ---- 1. accordions ---- */
  var accs = [];
  function Acc(body) {
    var self = this;
    this.body = body;
    this.trigger = root.querySelector('[data-accordion-trigger="' + body.id + '"]');
    this.on = false;
    this.click = function (e) { e.preventDefault(); self.toggle(); };
    this.key = function (e) { if (e.code === 'Escape') { self.hide(); self.trigger.focus(); } };
    this.close = function () { self.hide(); };
    accs.push(this);
  }
  Acc.prototype.enable = function () {
    if (!this.trigger) return;
    this.trigger.setAttribute('aria-haspopup', true);
    this.trigger.setAttribute('aria-expanded', false);
    this.trigger.setAttribute('aria-controls', this.body.id);
    if (!this.on) {
      this.on = true;
      this.trigger.addEventListener('click', this.click);
      this.body.addEventListener('keyup', this.key);
      this.body.addEventListener('theme:accordion:close', this.close);
    }
    if (this.trigger.classList.contains(OPEN)) { this.body.style.removeProperty('display'); this.body.style.display = ''; if (getComputedStyle(this.body).display === 'none') this.body.style.display = 'block'; } else this.hide();
  };
  Acc.prototype.disable = function () {
    if (!this.trigger || !this.on) return;
    this.on = false;
    this.trigger.removeEventListener('click', this.click);
    this.body.removeEventListener('keyup', this.key);
    this.body.removeEventListener('theme:accordion:close', this.close);
  };
  Acc.prototype.hide = function () {
    this.trigger.classList.remove(OPEN);
    slideUp(this.body);
  };
  Acc.prototype.show = function () {
    var self = this;
    this.trigger.classList.add(OPEN);
    slideDown(this.body);
    setTimeout(function () {
      var r = self.trigger.getBoundingClientRect();
      var inView = r.top >= 0 && r.left >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight) && r.right <= (window.innerWidth || document.documentElement.clientWidth);
      if (!inView) window.scrollTo({ top: (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0) + r.top, left: 0, behavior: 'smooth' });
    }, 600);
  };
  Acc.prototype.toggle = function () {
    if (this.trigger.classList.contains(OPEN)) { this.hide(); return; }
    this.show();
    var me = this.body;
    accs.forEach(function (a) { if (a.body !== me && a.body.parentNode && a.body.closest('[data-accordion-group]') === me.closest('[data-accordion-group]')) a.body.dispatchEvent(new CustomEvent('theme:accordion:close', { bubbles: false })); });
  };

  function bodiesOf() { return [].slice.call(root.querySelectorAll('[data-accordion-body]')); }
  function setupAcc() {
    bodiesOf().forEach(function (b) { if (b.hasAttribute('data-accordion-body-mobile')) new Acc(b); });
    var narrow = null;
    function apply() {
      var n = window.innerWidth < MEDIUM;
      if (n === narrow) return;
      narrow = n;
      accs.forEach(function (a) {
        if (n) a.enable();
        else { a.disable(); a.body.removeAttribute('style'); }
      });
    }
    apply();
    var t;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(apply, 150); });
  }

  /* ---- 2. newsletter ---- */
  function setupNewsletter() {
    [].forEach.call(root.querySelectorAll('[data-newsletter-form]'), function (form) {
      if (window.location.pathname === '/challenge') return;
      var stop = true, ss;
      try { ss = window.sessionStorage; } catch (e) {}
      form.addEventListener('submit', function (e) {
        if (!stop) return;
        e.preventDefault(); e.stopImmediatePropagation();
        try { ss.removeItem('newsletter_form_id'); ss.setItem('newsletter_form_id', form.id); } catch (er) {}
        stop = false;
        form.submit();
      });
      var id = null;
      try { id = ss.getItem('newsletter_form_id'); } catch (e) {}
      if (form.id === id) {
        if (window.location.search.indexOf('?customer_posted=true') !== -1) { form.classList.remove('has-error'); form.classList.add('has-success'); }
        else if (window.location.search.indexOf('accepts_marketing') !== -1) { form.classList.remove('has-success'); form.classList.add('has-error'); }
        try { ss.removeItem('newsletter_form_id'); } catch (e) {}
        var r = form.getBoundingClientRect();
        var vis = r.top >= 0 && r.left >= 0 && r.bottom <= (window.innerHeight || document.documentElement.clientHeight) && r.right <= (window.innerWidth || document.documentElement.clientWidth);
        if (!vis) setTimeout(function () { window.scroll({ top: r.top, left: 0, behavior: 'smooth' }); }, 400);
      }
    });
  }

  /* ---- 3. floating label ---- */
  function setupFloat() {
    [].forEach.call(root.querySelectorAll('.float__wrapper'), function (el) {
      var label = el.querySelector('label'), input = el.querySelector('input, textarea');
      if (!label || !input) return;
      input.addEventListener('keyup', function (e) { if (e.target.value !== '') label.classList.add('label--float'); else label.classList.remove('label--float'); });
      if (input.value && input.value.length) label.classList.add('label--float');
    });
  }

  function init() { setupAcc(); setupNewsletter(); setupFloat(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
